// ═══════════════════════════════════════
// Données démo — Elixir Prep
// ═══════════════════════════════════════

export const DEMO_USER = {
  id: 'demo',
  name: 'Démo',
  role: 'magasinier',
  active: true,
  isDemo: true,
};

export const DEMO_USER_RESP = {
  id: 'demo-resp',
  name: 'Démo Responsable',
  role: 'responsable',
  active: true,
  isDemo: true,
};

export const DEMO_SESSIONS = [
  {
    id: 'demo-1', date: new Date().toISOString().split('T')[0],
    partner_id: 1001, partner_name: 'PHARMACIE DU CENTRE',
    adresse: '12 rue de la Paix, 78000 Versailles',
    tournee: '1', order_refs: ['S130001'], status: 'en_cours',
    nb_amb: 0, nb_froid: 0, nb_cartons: 0, nb_cartons_vrac: 0,
    prepared_by: null, prepared_by_name: null, delivery_position: 1,
    created_at: new Date().toISOString(), updated_at: new Date().toISOString(),
  },
  {
    id: 'demo-2', date: new Date().toISOString().split('T')[0],
    partner_id: 1002, partner_name: 'PHARMACIE DE LA GARE',
    adresse: '45 avenue de la Gare, 78100 Saint-Germain',
    tournee: '1', order_refs: ['S130002', 'S130003'], status: 'en_cours',
    nb_amb: 0, nb_froid: 0, nb_cartons: 0, nb_cartons_vrac: 0,
    prepared_by: 'other-user', prepared_by_name: 'Jérémie', delivery_position: 2,
    created_at: new Date().toISOString(), updated_at: new Date().toISOString(),
  },
  {
    id: 'demo-3', date: new Date().toISOString().split('T')[0],
    partner_id: 1003, partner_name: 'PHARMACIE BLANQUI',
    adresse: '83 bd Auguste Blanqui, 75013 Paris',
    tournee: '2', order_refs: ['S130004'], status: 'en_cours',
    nb_amb: 2, nb_froid: 1, nb_cartons: 1, nb_cartons_vrac: 0,
    prepared_by: 'demo', prepared_by_name: 'Gaye', delivery_position: 1,
    created_at: new Date().toISOString(), updated_at: new Date().toISOString(),
  },
  {
    id: 'demo-4', date: new Date().toISOString().split('T')[0],
    partner_id: 1004, partner_name: 'PHARMACIE DU MARCHÉ',
    adresse: '8 place du Marché, 78300 Poissy',
    tournee: '2', order_refs: ['S130005'], status: 'prete',
    nb_amb: 1, nb_froid: 1, nb_cartons: 2, nb_cartons_vrac: 0,
    prepared_by: 'demo', prepared_by_name: 'Alexandre', delivery_position: 2,
    created_at: new Date().toISOString(), updated_at: new Date().toISOString(),
  },
  {
    id: 'demo-5', date: new Date().toISOString().split('T')[0],
    partner_id: 1005, partner_name: 'PHARMACIE DES ARCADES',
    adresse: '15 rue des Arcades, 78150 Le Chesnay',
    tournee: '3', order_refs: ['S130006'], status: 'en_cours',
    nb_amb: 0, nb_froid: 0, nb_cartons: 0, nb_cartons_vrac: 0,
    prepared_by: null, prepared_by_name: null, delivery_position: 1,
    created_at: new Date().toISOString(), updated_at: new Date().toISOString(),
  },
];

export const DEMO_PRODUCTS = {
  'demo-1': [
    { id: 1, name: 'DOLIPRANE 1000 mg (paracétamol), comprimés (B/8)', product_name: 'DOLIPRANE 1000 mg', total_qty: 5, cip: '3400930018972', orders: ['S130001'] },
    { id: 2, name: 'AMOXICILLINE 500 mg, gélules (B/12)', product_name: 'AMOXICILLINE 500 mg', total_qty: 3, cip: '3400930045343', orders: ['S130001'] },
  ],
  'demo-2': [
    { id: 3, name: 'VENTOLINE 100µg, suspension pour inhalation (B/1)', product_name: 'VENTOLINE 100µg', total_qty: 2, cip: '3400930216453', orders: ['S130002'] },
    { id: 4, name: 'KARDEGIC 75 mg, poudre pour solution buvable (B/30)', product_name: 'KARDEGIC 75 mg', total_qty: 10, cip: '3400933797508', orders: ['S130002'] },
    { id: 5, name: 'LEVOTHYROX 50µg, comprimés sécables (B/30)', product_name: 'LEVOTHYROX 50µg', total_qty: 4, cip: '3400933838980', orders: ['S130003'] },
  ],
  'demo-3': [
    { id: 6, name: 'INSULATARD 100 UI/ml, suspension injectable (B/5)', product_name: 'INSULATARD 100 UI/ml', total_qty: 2, cip: '3400935137340', orders: ['S130004'] },
  ],
  'demo-4': [
    { id: 7, name: 'XARELTO 20 mg (rivaroxaban), comprimés (B/28)', product_name: 'XARELTO 20 mg', total_qty: 1, cip: '3400936497931', orders: ['S130005'] },
    { id: 8, name: 'ELIQUIS 5 mg (apixaban), comprimés (B/60)', product_name: 'ELIQUIS 5 mg', total_qty: 3, cip: '3400937068291', orders: ['S130005'] },
  ],
  'demo-5': [
    { id: 9, name: 'SERETIDE DISKUS 500/50µg, poudre pour inhalation (B/60)', product_name: 'SERETIDE DISKUS', total_qty: 1, cip: '3400937784214', orders: ['S130006'] },
    { id: 10, name: 'SPIRIVA 18µg, gélules pour inhalation (B/30)', product_name: 'SPIRIVA 18µg', total_qty: 2, cip: '3400930204887', orders: ['S130006'] },
    { id: 11, name: 'SYMBICORT 200/6µg, suspension pour inhalation (B/120)', product_name: 'SYMBICORT 200/6µg', total_qty: 1, cip: '3400938580259', orders: ['S130006'] },
  ],
};

export const TUTORIAL_STEPS = [
  {
    title: 'Bienvenue sur Elixir Prep !',
    text: 'Cette app te guide pour préparer les commandes pharmacie. Voici comment ça marche en 4 étapes.',
    icon: '👋',
  },
  {
    title: '1. Choisis ta tournée',
    text: 'Les tournées sont classées par priorité. La première qui a du travail s\'ouvre automatiquement. Tape sur une pharmacie pour commencer.',
    icon: '📋',
  },
  {
    title: '2. Prépare la commande',
    text: 'Tu vois les produits à préparer. Scanne les caisses (amb/froid), prends les photos, signale les anomalies si besoin.',
    icon: '📦',
  },
  {
    title: '3. Photos obligatoires',
    text: 'Tape "Prendre des photos" → la caméra s\'ouvre. Appuie sur le déclencheur autant de fois que nécessaire. Tape "Terminer" quand c\'est bon.',
    icon: '📷',
  },
  {
    title: '4. Valide la préparation',
    text: 'Quand tout est fait (caisses + photos), tape "Prête à partir". La commande passe en vert. C\'est tout !',
    icon: '✅',
  },
];
